export default __webpack_public_path__ + "static/checknlearn-promo-small@3x-f030cc7aa91df4dd12e1561ea331eef8.jpg";